import { Component, OnInit,ViewChild } from '@angular/core';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { MdlTextFieldComponent  } from '../../lib/components';
import { MdlDialogService ,MdlDialogReference } from '../../lib/components/dialog/index';
import { Router} from '@angular/router';
import { IUsers } from '../database';
import { LoginService } from '../service';
@Component({

  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    @ViewChild('firstElement')  private inputElement: MdlTextFieldComponent;
     public loginForm: FormGroup;
    errorMessage: string;
  public processingLogin = false;
  public statusMessage = '';
  private currentUser :IUsers ; 
  constructor(private fb: FormBuilder,private _loginService:LoginService, private router: Router,private dialogService: MdlDialogService) { }

  ngOnInit() {
     this.loginForm =  this.fb.group({
      'username' : ["", Validators.required],
      'password': ["", Validators.required]
    })
    this.inputElement.setFocus(); 
  }
  alertMsg(title,message){
    let pDialog = this.dialogService.showDialog({
          title: title,
          message: message,
          actions: [
            {
              handler: () => {
                       this.processingLogin = false;
                       this.statusMessage = '';
                },
                text: 'ok' ,
                isClosingAction: false
              }
            ],
            fullWidthAction: true,
            isModal: false,
            animate: false
          });
          pDialog.subscribe( (dialogReference) => console.log('dialog visible', dialogReference) );
 }
  submitForm(): void {  
      this.processingLogin = true;
      this.statusMessage = 'checking your credentials ...';
      this._loginService.login(this.loginForm.value)
      .subscribe(user=>this.onSuccess(user),error => this.errorMessage = <any>error); 
      
     }
  onSuccess(data:any){
     this.processingLogin = false;
     this.statusMessage = '';
     if(data.success){
          localStorage.setItem('UserInfo', JSON.stringify(data.data) )
          this.router.navigate(['../dashboard']);
     }else{
         this.alertMsg("",data.mes);
     }
  }
}
 


// WEBPACK FOOTER //
// ./src/app/login/login.component.ts